const VISA_DATA_URL =
    'https://raw.githubusercontent.com/maxix7/visa-requirements-dataset/main/data/visa-requirements.json';

let visaData = null;

export const loadVisaData = async () => {
    if (visaData) {
        return visaData;
    }

    const response = await fetch(VISA_DATA_URL);

    if (!response.ok) {
        throw new Error('Failed to load visa data');
    }

    visaData = await response.json();

    return visaData;
};

export const getVisaInfo = async (passport, destination) => {
    const data = await loadVisaData();
    return data.rules?.[passport]?.[destination] || null;
};